import { Directive, ElementRef, HostListener, AfterViewInit, Renderer2, Input } from '@angular/core';
import { TextHelper } from '../helpers/text.helper';

@Directive({
  selector: '[sharedAdjustWidth]',
  standalone: false,
})
export class AdjustWidthDirective implements AfterViewInit {
  @Input() minWidth = 120;
  @Input() maxWidth?: number; // If not set, uses parent width
  @Input() padding = 8;

  private input: HTMLInputElement;

  constructor(private el: ElementRef<HTMLInputElement>, private renderer: Renderer2) {
    this.input = this.el.nativeElement;
  }

  ngAfterViewInit(): void {
    this.adjustWidth();
  }

  @HostListener('input')
  onInput(): void {
    this.adjustWidth();
  }

  private adjustWidth(): void {
    const value = this.input.value || this.input.placeholder || '';
    // Calculate width even for empty values to allow shrinking
    const textWidth = TextHelper.getTextWidth(value, TextHelper.getCanvasFont(this.input), 0);
    let finalWidth = Math.max(textWidth + (this.padding * 2), this.minWidth);

    // Apply max width constraint
    if (this.maxWidth) {
      finalWidth = Math.min(finalWidth, this.maxWidth);
    }

    this.renderer.setStyle(this.input, 'width', `${finalWidth}px`);
  }
}
